'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Button from '@mui/material/Button';
import { usePopoverContext } from './PopoverContext';
import useMergedRefs from '@restart/hooks/useMergedRefs';
import { composeEventHandlers } from '../utils/composeEventHandlers';
export const PopoverButton = React.forwardRef(({ component: Component = Button, onClick, ...props }, ref) => {
    const { open, handleToggle, anchorRef, popoverId } = usePopoverContext('Button');
    const mergedRef = useMergedRefs(anchorRef, ref);
    const onClickEvents = composeEventHandlers(handleToggle, onClick);
    return (_jsx(Component, { "aria-controls": open ? popoverId : undefined, "aria-expanded": open, "aria-haspopup": 'dialog', onClick: onClickEvents, ref: mergedRef, ...props }));
});
PopoverButton.displayName = 'PopoverButton';
